import { createClient } from '@supabase/supabase-js';
import { normalizeSupabaseAnonKey, normalizeSupabaseUrl } from './supabaseEnv';

const supabaseUrl =
  normalizeSupabaseUrl(import.meta.env.VITE_SUPABASE_URL) || 'https://placeholder.supabase.co';
const supabaseAnonKey =
  normalizeSupabaseAnonKey(import.meta.env.VITE_SUPABASE_ANON_KEY) || 'placeholder-key';

if (
  !normalizeSupabaseUrl(import.meta.env.VITE_SUPABASE_URL) ||
  !normalizeSupabaseAnonKey(import.meta.env.VITE_SUPABASE_ANON_KEY)
) {
  console.warn('Missing Supabase environment variables. Please check your .env file.');
}

// Configure Supabase client with proper auth flow and CORS handling
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    fetch: (...args) => fetch(...args),
  },
  realtime: {
    // Suppress WebSocket connection errors in console
    // Errors will be handled in subscription callbacks
    params: {
      eventsPerSecond: 10,
    },
  },
});
